export class Detail {
    name: string;
    values: string[];

    constructor(name: string, values: string[]){
        this.name = name;
        this.values = values;
    };
}

export function toDetailMap(arr: Detail[]): Map<string, string[]> {
    const detailMap = new Map<string, string[]>();

    if (arr.length > 0) {
        for (const detail of arr) {
           detailMap.set(detail.name, detail.values);
        }
    };

    return detailMap;
}